export default __webpack_public_path__ + "static/media/wallace.fcf69542.png";